<template>
    <div>
        <span v-if="isrequired" class="info-icon-required">*</span>
        <span>{{info.label}}</span>
        <span v-if="info.tip"
            class="fa fa-question-circle-o info-icon"
            @click="toggleShowTip"></span>
        <span>:</span>

        <div v-html="info.tip"
            :class="isShow ? 'info-icon-tip' : 'info-icon-tip-hide'">
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            info: {
                'type': Object,
                'default': () => {}
            },
            isrequired: {
                'type': Boolean,
                'default': true
            }
        },
        data() {
            return {
                isShow: false
            };
        },
        mounted() {
            this.globalClick(this.hideTip);
        },
        methods: {
            hideTip(target) {
                if (!(typeof target.className === 'string' && target.className.indexOf('info-icon') > -1)) {
                    this.isShow = false;
                }
            },
            toggleShowTip() {
                this.isShow = !this.isShow;
            }
        }
    };
</script>

<style scoped lang="less">
    .info-icon {
        position: relative;
        color: #0072eb;
        margin: 0 5px;
        cursor: pointer;

        &-required {
            color: #e63e63;
            font-size: 16px;
        }

        &-tip {
            position: absolute;
            z-index: 15;
            padding: 10px 20px;
            border: 1px solid #ccc;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .06);
            text-align: left;
            background-color: #fff;

            &>a {
                color: #0073eb;
            }

            &-hide {
                display: none;
            }
        }
    }

</style>
